export default {
	"Seule": [
		{
			"18": "7529",
			"19": "7529",
			"20": "7529",
			"21": "35302",
			"22": "36471",
			"23": "37987",
			"24": "39302",
			"25": "40854",
			"26": "42279",
			"27": "44014",
			"28": "45639",
			"29": "47374",
			"30": "49127",
			"31": "50990",
			"32": "52963",
			"33": "52963",
			"34": "52963",
			"35": "52963",
			"36": "52963",
			"37": "52963",
			"38": "52963",
			"39": "52963",
			"40": "52963",
			"41": "52963",
			"42": "52963",
			"43": "52963",
			"44": "52963",
			"45": "52963",
			"46": "52963",
			"47": "52963",
			"48": "52963",
			"49": "52963",
			"50": "52963",
			"51": "52963",
			"52": "52963",
			"53": "52963",
			"54": "52963",
			"55": "52963",
			"56": "52963",
			"57": "52963",
			"58": "52963",
			"59": "52963",
			"60": "0",
			"61": "0",
			"62": "0",
			"63": "0",
			"64": "0",
			"65": "0",
			"66": "0",
			"67": "0",
			"68": "0",
			"69": "0",
			"70": "0",
			"71": "0",
			"72": "0",
			"73": "0",
			"74": "0",
			"75": "0",
			"76": "0",
			"77": "0",
			"78": "0",
			"79": "0",
			"80": "0",
			"81": "0",
			"82": "0",
			"83": "0",
			"84": "0",
			"85": "0",
			"86": "0",
			"87": "0",
			"category": "revenu-salaire"
		},
		{
			"18": "0",
			"19": "0",
			"20": "0",
			"21": "0",
			"22": "0",
			"23": "0",
			"24": "0",
			"25": "0",
			"26": "0",
			"27": "0",
			"28": "0",
			"29": "0",
			"30": "0",
			"31": "0",
			"32": "0",
			"33": "0",
			"34": "0",
			"35": "0",
			"36": "0",
			"37": "0",
			"38": "0",
			"39": "0",
			"40": "0",
			"41": "0",
			"42": "0",
			"43": "0",
			"44": "0",
			"45": "0",
			"46": "0",
			"47": "0",
			"48": "0",
			"49": "0",
			"50": "0",
			"51": "0",
			"52": "0",
			"53": "0",
			"54": "0",
			"55": "0",
			"56": "0",
			"57": "0",
			"58": "0",
			"59": "0",
			"60": "41311",
			"61": "41311",
			"62": "41311",
			"63": "41311",
			"64": "41311",
			"65": "28335",
			"66": "28335",
			"67": "28335",
			"68": "28335",
			"69": "28335",
			"70": "28335",
			"71": "28335",
			"72": "28335",
			"73": "28335",
			"74": "28335",
			"75": "28335",
			"76": "28335",
			"77": "28335",
			"78": "28335",
			"79": "28335",
			"80": "28335",
			"81": "28335",
			"82": "28335",
			"83": "28335",
			"84": "28335",
			"85": "28335",
			"86": "28335",
			"87": "28335",
			"category": "revenu-retraite"
		},
		{
			"18": "0",
			"19": "0",
			"20": "0",
			"21": "4466",
			"22": "4732",
			"23": "5092",
			"24": "5424",
			"25": "5816",
			"26": "6176",
			"27": "6614",
			"28": "7024",
			"29": "7462",
			"30": "7935",
			"31": "8441",
			"32": "9046",
			"33": "9046",
			"34": "9046",
			"35": "9046",
			"36": "9046",
			"37": "9046",
			"38": "9046",
			"39": "9046",
			"40": "9046",
			"41": "9046",
			"42": "9046",
			"43": "9046",
			"44": "9046",
			"45": "9046",
			"46": "9046",
			"47": "9046",
			"48": "9046",
			"49": "9046",
			"50": "9046",
			"51": "9046",
			"52": "9046",
			"53": "9046",
			"54": "9046",
			"55": "9046",
			"56": "9046",
			"57": "9046",
			"58": "9046",
			"59": "9046",
			"60": "6915",
			"61": "9981",
			"62": "9981",
			"63": "9981",
			"64": "9981",
			"65": "6504",
			"66": "6504",
			"67": "6504",
			"68": "6504",
			"69": "6504",
			"70": "6504",
			"71": "6504",
			"72": "6504",
			"73": "6504",
			"74": "6504",
			"75": "6504",
			"76": "6504",
			"77": "6504",
			"78": "6504",
			"79": "6504",
			"80": "6504",
			"81": "6504",
			"82": "6504",
			"83": "6504",
			"84": "6504",
			"85": "6504",
			"86": "6504",
			"87": "6504",
			"category": "impot"
		},
		{
			"18": "218",
			"19": "218",
			"20": "218",
			"21": "1717",
			"22": "1780",
			"23": "1862",
			"24": "1933",
			"25": "2017",
			"26": "2094",
			"27": "2188",
			"28": "2276",
			"29": "2369",
			"30": "2464",
			"31": "2564",
			"32": "2671",
			"33": "2671",
			"34": "2671",
			"35": "2671",
			"36": "2671",
			"37": "2671",
			"38": "2671",
			"39": "2671",
			"40": "2671",
			"41": "2671",
			"42": "2671",
			"43": "2671",
			"44": "2671",
			"45": "2671",
			"46": "2671",
			"47": "2671",
			"48": "2671",
			"49": "2671",
			"50": "2671",
			"51": "2671",
			"52": "2671",
			"53": "2671",
			"54": "2671",
			"55": "2671",
			"56": "2671",
			"57": "2671",
			"58": "2671",
			"59": "2671",
			"category": "rrq"
		},
		{
			"18": "41",
			"19": "41",
			"20": "41",
			"21": "193",
			"22": "200",
			"23": "208",
			"24": "215",
			"25": "224",
			"26": "232",
			"27": "241",
			"28": "250",
			"29": "260",
			"30": "269",
			"31": "279",
			"32": "290",
			"33": "290",
			"34": "290",
			"35": "290",
			"36": "290",
			"37": "290",
			"38": "290",
			"39": "290",
			"40": "290",
			"41": "290",
			"42": "290",
			"43": "290",
			"44": "290",
			"45": "290",
			"46": "290",
			"47": "290",
			"48": "290",
			"49": "290",
			"50": "290",
			"51": "290",
			"52": "290",
			"53": "290",
			"54": "290",
			"55": "290",
			"56": "290",
			"57": "290",
			"58": "290",
			"59": "290",
			"61": "0",
			"62": "0",
			"63": "0",
			"64": "0",
			"65": "0",
			"66": "0",
			"67": "0",
			"68": "0",
			"69": "0",
			"70": "0",
			"71": "0",
			"72": "0",
			"73": "0",
			"74": "0",
			"75": "0",
			"76": "0",
			"77": "0",
			"78": "0",
			"79": "0",
			"80": "0",
			"81": "0",
			"82": "0",
			"83": "0",
			"84": "0",
			"85": "0",
			"86": "0",
			"87": "0",
			"category": "rqap"
		},
		{
			"18": "98",
			"19": "98",
			"20": "98",
			"21": "459",
			"22": "474",
			"23": "494",
			"24": "511",
			"25": "531",
			"26": "550",
			"27": "572",
			"28": "593",
			"29": "616",
			"30": "639",
			"31": "663",
			"32": "672",
			"33": "672",
			"34": "672",
			"35": "672",
			"36": "672",
			"37": "672",
			"38": "672",
			"39": "672",
			"40": "672",
			"41": "672",
			"42": "672",
			"43": "672",
			"44": "672",
			"45": "672",
			"46": "672",
			"47": "672",
			"48": "672",
			"49": "672",
			"50": "672",
			"51": "672",
			"52": "672",
			"53": "672",
			"54": "672",
			"55": "672",
			"56": "672",
			"57": "672",
			"58": "672",
			"59": "672",
			"category": "ae"
		},
		{
			"18": "1188",
			"19": "1188",
			"20": "1188",
			"21": "1759",
			"22": "1759",
			"23": "1759",
			"24": "1759",
			"25": "2239",
			"26": "2239",
			"27": "2239",
			"28": "2239",
			"29": "2239",
			"30": "2323",
			"31": "2323",
			"32": "2323",
			"33": "2323",
			"34": "2323",
			"35": "2344",
			"36": "2344",
			"37": "2344",
			"38": "2344",
			"39": "2344",
			"40": "2352",
			"41": "2352",
			"42": "2352",
			"43": "2352",
			"44": "2352",
			"45": "2349",
			"46": "2349",
			"47": "2349",
			"48": "2349",
			"49": "2349",
			"50": "2334",
			"51": "2334",
			"52": "2334",
			"53": "2334",
			"54": "2334",
			"55": "2307",
			"56": "2307",
			"57": "2307",
			"58": "2307",
			"59": "2307",
			"60": "2268",
			"61": "2268",
			"62": "2268",
			"63": "2268",
			"64": "2268",
			"65": "2217",
			"66": "2217",
			"67": "2217",
			"68": "2217",
			"69": "2217",
			"70": "2154",
			"71": "2154",
			"72": "2154",
			"73": "2154",
			"74": "2154",
			"75": "2080",
			"76": "2080",
			"77": "2080",
			"78": "2080",
			"79": "2080",
			"80": "1993",
			"81": "1993",
			"82": "1993",
			"83": "1993",
			"84": "1993",
			"85": "1895",
			"86": "1895",
			"87": "1895",
			"category": "taxes"
		},
		{
			"60": "150",
			"61": "150",
			"62": "150",
			"63": "150",
			"64": "150",
			"65": "150",
			"66": "150",
			"67": "150",
			"68": "150",
			"69": "150",
			"70": "150",
			"71": "150",
			"72": "150",
			"73": "150",
			"74": "150",
			"75": "150",
			"76": "150",
			"77": "150",
			"78": "150",
			"79": "150",
			"80": "150",
			"81": "150",
			"82": "150",
			"83": "150",
			"84": "150",
			"85": "150",
			"86": "150",
			"87": "150",
			"category": "fond-service-sante"
		},
		{
			"60": "642",
			"61": "642",
			"62": "642",
			"63": "642",
			"64": "642",
			"65": "642",
			"66": "642",
			"67": "642",
			"68": "642",
			"69": "642",
			"70": "642",
			"71": "642",
			"72": "642",
			"73": "642",
			"74": "642",
			"75": "642",
			"76": "642",
			"77": "642",
			"78": "642",
			"79": "642",
			"80": "642",
			"81": "642",
			"82": "642",
			"83": "642",
			"84": "642",
			"85": "642",
			"86": "642",
			"87": "642",
			"category": "regime-assurance-medicament"
		},
		{
			"18": "284",
			"19": "284",
			"20": "284",
			"21": "433",
			"22": "433",
			"23": "433",
			"24": "433",
			"25": "399",
			"26": "338",
			"27": "264",
			"28": "194",
			"29": "119",
			"30": "44",
			"31": "0",
			"32": "0",
			"33": "0",
			"34": "0",
			"35": "0",
			"36": "0",
			"37": "0",
			"38": "0",
			"39": "0",
			"40": "0",
			"41": "0",
			"42": "0",
			"43": "0",
			"44": "0",
			"45": "0",
			"46": "0",
			"47": "0",
			"48": "0",
			"49": "0",
			"50": "0",
			"51": "0",
			"52": "0",
			"53": "0",
			"54": "0",
			"55": "0",
			"56": "0",
			"57": "0",
			"58": "0",
			"59": "0",
			"60": "216",
			"61": "0",
			"62": "0",
			"63": "0",
			"64": "0",
			"65": "84",
			"66": "84",
			"67": "84",
			"68": "84",
			"69": "84",
			"70": "84",
			"71": "84",
			"72": "84",
			"73": "84",
			"74": "84",
			"75": "84",
			"76": "84",
			"77": "84",
			"78": "84",
			"79": "84",
			"80": "84",
			"81": "84",
			"82": "84",
			"83": "84",
			"84": "84",
			"85": "84",
			"86": "84",
			"87": "84",
			"category": "credit-tps"
		},
		{
			"18": "287",
			"19": "287",
			"20": "287",
			"21": "981",
			"22": "981",
			"23": "962",
			"24": "893",
			"25": "812",
			"26": "737",
			"27": "647",
			"28": "562",
			"29": "471",
			"30": "379",
			"31": "282",
			"32": "179",
			"33": "179",
			"34": "179",
			"35": "179",
			"36": "179",
			"37": "179",
			"38": "179",
			"39": "179",
			"40": "179",
			"41": "179",
			"42": "179",
			"43": "179",
			"44": "179",
			"45": "179",
			"46": "179",
			"47": "179",
			"48": "179",
			"49": "179",
			"50": "179",
			"51": "179",
			"52": "179",
			"53": "179",
			"54": "179",
			"55": "179",
			"56": "179",
			"57": "179",
			"58": "179",
			"59": "179",
			"60": "555",
			"61": "45",
			"62": "45",
			"63": "45",
			"64": "45",
			"65": "396",
			"66": "396",
			"67": "396",
			"68": "396",
			"69": "396",
			"70": "396",
			"71": "396",
			"72": "396",
			"73": "396",
			"74": "396",
			"75": "396",
			"76": "396",
			"77": "396",
			"78": "396",
			"79": "396",
			"80": "396",
			"81": "396",
			"82": "396",
			"83": "396",
			"84": "396",
			"85": "396",
			"86": "396",
			"87": "396",
			"category": "credit-solidarite"
		},
		{
			"65": "7121",
			"66": "7121",
			"67": "7121",
			"68": "7121",
			"69": "7121",
			"70": "7121",
			"71": "7121",
			"72": "7121",
			"73": "7121",
			"74": "7121",
			"75": "7121",
			"76": "7121",
			"77": "7121",
			"78": "7121",
			"79": "7121",
			"80": "7121",
			"81": "7121",
			"82": "7121",
			"83": "7121",
			"84": "7121",
			"85": "7121",
			"86": "7121",
			"87": "7121",
			"category": "pension"
		},
		{
			"75": "605",
			"76": "605",
			"77": "605",
			"78": "605",
			"79": "605",
			"80": "605",
			"81": "605",
			"82": "605",
			"83": "605",
			"84": "605",
			"85": "605",
			"86": "605",
			"87": "605",
			"category": "cisd"
		},
		{
			"18": "1668",
			"19": "1668",
			"20": "1945",
			"21": "1945",
			"22": "1945",
			"23": "1945",
			"24": "1945",
			"25": "2706",
			"26": "2706",
			"27": "2706",
			"28": "2706",
			"29": "2706",
			"30": "2884",
			"31": "2884",
			"32": "2884",
			"33": "2884",
			"34": "2884",
			"35": "2540",
			"36": "2540",
			"37": "2540",
			"38": "2540",
			"39": "2540",
			"40": "2297",
			"41": "2297",
			"42": "2297",
			"43": "2297",
			"44": "2297",
			"45": "2531",
			"46": "2531",
			"47": "2531",
			"48": "2531",
			"49": "2531",
			"50": "2910",
			"51": "2910",
			"52": "2910",
			"53": "2910",
			"54": "2910",
			"55": "3452",
			"56": "3452",
			"57": "3452",
			"58": "3452",
			"59": "3452",
			"60": "4333",
			"61": "4333",
			"62": "4333",
			"63": "4333",
			"64": "4333",
			"65": "5975",
			"66": "5975",
			"67": "5975",
			"68": "5975",
			"69": "5975",
			"70": "7704",
			"71": "7704",
			"72": "7704",
			"73": "7704",
			"74": "7704",
			"75": "11129",
			"76": "11129",
			"77": "11129",
			"78": "11129",
			"79": "11129",
			"80": "16782",
			"81": "16782",
			"82": "16782",
			"83": "16782",
			"84": "16782",
			"85": "28143",
			"86": "28143",
			"87": "28143",
			"category": "sante"
		},
		{
			"18": "12238",
			"19": "12238",
			"20": "12238",
			"category": "service-es"
		},
		{
			"18": "0",
			"19": "0",
			"20": "0",
			"21": "0",
			"22": "0",
			"23": "0",
			"24": "0",
			"25": "0",
			"26": "0",
			"27": "0",
			"28": "0",
			"29": "0",
			"30": "0",
			"31": "0",
			"32": "0",
			"33": "0",
			"34": "0",
			"35": "0",
			"36": "0",
			"37": "0",
			"38": "0",
			"39": "0",
			"40": "0",
			"41": "0",
			"42": "0",
			"43": "0",
			"44": "0",
			"45": "0",
			"46": "0",
			"47": "0",
			"48": "0",
			"49": "0",
			"50": "0",
			"51": "0",
			"52": "0",
			"53": "0",
			"54": "0",
			"55": "0",
			"56": "0",
			"57": "0",
			"58": "0",
			"59": "0",
			"60": "505",
			"61": "9010",
			"62": "9010",
			"63": "9010",
			"64": "9010",
			"65": "9877",
			"66": "9877",
			"67": "9877",
			"68": "9877",
			"69": "9877",
			"70": "9877",
			"71": "9877",
			"72": "9877",
			"73": "9877",
			"74": "9877",
			"75": "9877",
			"76": "9877",
			"77": "9877",
			"78": "9877",
			"79": "9877",
			"80": "9877",
			"81": "9877",
			"82": "9877",
			"83": "9877",
			"84": "9877",
			"85": "9877",
			"86": "9877",
			"87": "9877",
			"category": "prestations-publiques"
		},
		{
			"61": "8505",
			"62": "8505",
			"63": "8505",
			"64": "8505",
			"65": "8505",
			"66": "8505",
			"67": "8505",
			"68": "8505",
			"69": "8505",
			"70": "8505",
			"71": "8505",
			"72": "8505",
			"73": "8505",
			"74": "8505",
			"75": "8505",
			"76": "8505",
			"77": "8505",
			"78": "8505",
			"79": "8505",
			"80": "8505",
			"81": "8505",
			"82": "8505",
			"83": "8505",
			"84": "8505",
			"85": "8505",
			"86": "8505",
			"87": "8505",
			"category": "rentes"
		},
		{
			"60": "505",
			"61": "505",
			"62": "505",
			"63": "505",
			"64": "505",
			"65": "1372",
			"66": "1372",
			"67": "1372",
			"68": "1372",
			"69": "1372",
			"70": "1372",
			"71": "1372",
			"72": "1372",
			"73": "1372",
			"74": "1372",
			"75": "1372",
			"76": "1372",
			"77": "1372",
			"78": "1372",
			"79": "1372",
			"80": "1372",
			"81": "1372",
			"82": "1372",
			"83": "1372",
			"84": "1372",
			"85": "1372",
			"86": "1372",
			"87": "1372",
			"category": "assurance-medicament"
		}
	],
	"En couple": [
		{
			"18": "7529",
			"19": "7529",
			"20": "7529",
			"21": "35302",
			"22": "36471",
			"23": "37987",
			"24": "39302",
			"25": "40854",
			"26": "42279",
			"27": "93443",
			"28": "96067",
			"29": "48148",
			"30": "101552",
			"31": "50154",
			"32": "107385",
			"33": "108384",
			"34": "109383",
			"35": "110381",
			"36": "111380",
			"37": "112379",
			"38": "113377",
			"39": "114376",
			"40": "115375",
			"41": "116019",
			"42": "116019",
			"43": "116019",
			"44": "116019",
			"45": "116019",
			"46": "116019",
			"47": "116019",
			"48": "116019",
			"49": "116019",
			"50": "116019",
			"51": "116019",
			"52": "116019",
			"53": "116019",
			"54": "116019",
			"55": "116019",
			"56": "116019",
			"57": "116019",
			"58": "116019",
			"59": "116019",
			"60": "0",
			"61": "0",
			"62": "0",
			"63": "0",
			"64": "0",
			"65": "0",
			"66": "0",
			"67": "0",
			"68": "0",
			"69": "0",
			"70": "0",
			"71": "0",
			"72": "0",
			"73": "0",
			"74": "0",
			"75": "0",
			"76": "0",
			"77": "0",
			"78": "0",
			"79": "0",
			"80": "0",
			"81": "0",
			"82": "0",
			"83": "0",
			"84": "0",
			"85": "0",
			"86": "0",
			"87": "0",
			"category": "revenu-salaire"
		},
		{
			"18": "0",
			"19": "0",
			"20": "0",
			"21": "0",
			"22": "0",
			"23": "0",
			"24": "0",
			"25": "0",
			"26": "0",
			"27": "0",
			"28": "0",
			"29": "0",
			"30": "0",
			"31": "0",
			"32": "0",
			"33": "0",
			"34": "0",
			"35": "0",
			"36": "0",
			"37": "0",
			"38": "0",
			"39": "0",
			"40": "0",
			"41": "0",
			"42": "0",
			"43": "0",
			"44": "0",
			"45": "0",
			"46": "0",
			"47": "0",
			"48": "0",
			"49": "0",
			"50": "0",
			"51": "0",
			"52": "0",
			"53": "0",
			"54": "0",
			"55": "0",
			"56": "0",
			"57": "0",
			"58": "0",
			"59": "0",
			"60": "50086",
			"61": "50086",
			"62": "50086",
			"63": "50086",
			"64": "50086",
			"65": "37110",
			"66": "37110",
			"67": "37110",
			"68": "37110",
			"69": "37110",
			"70": "37110",
			"71": "37110",
			"72": "37110",
			"73": "37110",
			"74": "37110",
			"75": "37110",
			"76": "37110",
			"77": "37110",
			"78": "37110",
			"79": "37110",
			"80": "37110",
			"81": "37084",
			"82": "28335",
			"83": "28335",
			"84": "28335",
			"85": "28335",
			"86": "28335",
			"87": "28335",
			"category": "revenu-retraite"
		},
		{
			"18": "0",
			"19": "0",
			"20": "0",
			"21": "4466",
			"22": "4732",
			"23": "5092",
			"24": "5424",
			"25": "5816",
			"26": "6176",
			"27": "16228",
			"28": "15599",
			"29": "13274",
			"30": "16834",
			"31": "12881",
			"32": "18265",
			"33": "18622",
			"34": "19098",
			"35": "19464",
			"36": "20012",
			"37": "20382",
			"38": "20503",
			"39": "20873",
			"40": "21243",
			"41": "21955",
			"42": "21955",
			"43": "21955",
			"44": "21955",
			"45": "21955",
			"46": "21014",
			"47": "21682",
			"48": "20740",
			"49": "21408",
			"50": "21682",
			"51": "21682",
			"52": "21955",
			"53": "21955",
			"54": "21955",
			"55": "21955",
			"56": "21955",
			"57": "21955",
			"58": "21955",
			"59": "21955",
			"60": "8601",
			"61": "11377",
			"62": "12323",
			"63": "12323",
			"64": "12323",
			"65": "8834",
			"66": "8834",
			"67": "8834",
			"68": "8834",
			"69": "8834",
			"70": "8834",
			"71": "8834",
			"72": "8834",
			"73": "8834",
			"74": "8834",
			"75": "8834",
			"76": "8834",
			"77": "8834",
			"78": "8834",
			"79": "8834",
			"80": "8834",
			"81": "8834",
			"82": "8063",
			"83": "8063",
			"84": "8063",
			"85": "8063",
			"86": "8063",
			"87": "8063",
			"category": "impot"
		},
		{
			"30": "650",
			"31": "168",
			"32": "1267",
			"33": "1322",
			"34": "917",
			"35": "953",
			"category": "frais-de-garde"
		},
		{
			"18": "218",
			"19": "218",
			"20": "218",
			"21": "1717",
			"22": "1780",
			"23": "1862",
			"24": "1933",
			"25": "2017",
			"26": "2094",
			"27": "4668",
			"28": "4810",
			"29": "2222",
			"30": "5106",
			"31": "2330",
			"32": "5421",
			"33": "5479",
			"34": "5501",
			"35": "5501",
			"36": "5501",
			"37": "5501",
			"38": "5501",
			"39": "5501",
			"40": "5501",
			"41": "5501",
			"42": "5501",
			"43": "5501",
			"44": "5501",
			"45": "5501",
			"46": "5501",
			"47": "5501",
			"48": "5501",
			"49": "5501",
			"50": "5501",
			"51": "5501",
			"52": "5501",
			"53": "5501",
			"54": "5501",
			"55": "5501",
			"56": "5501",
			"57": "5501",
			"58": "5501",
			"59": "5501",
			"60": "0",
			"61": "0",
			"62": "0",
			"63": "0",
			"64": "0",
			"65": "0",
			"66": "0",
			"67": "0",
			"68": "0",
			"69": "0",
			"70": "0",
			"71": "0",
			"72": "0",
			"73": "0",
			"74": "0",
			"75": "0",
			"76": "0",
			"77": "0",
			"78": "0",
			"79": "0",
			"80": "0",
			"81": "0",
			"82": "0",
			"83": "0",
			"84": "0",
			"85": "0",
			"86": "0",
			"87": "0",
			"category": "rrq"
		},
		{
			"18": "41",
			"19": "41",
			"20": "41",
			"21": "193",
			"22": "200",
			"23": "208",
			"24": "215",
			"25": "224",
			"26": "232",
			"27": "512",
			"28": "526",
			"29": "264",
			"30": "556",
			"31": "275",
			"32": "588",
			"33": "594",
			"34": "599",
			"35": "605",
			"36": "610",
			"37": "616",
			"38": "621",
			"39": "627",
			"40": "632",
			"41": "636",
			"42": "636",
			"43": "636",
			"44": "636",
			"45": "636",
			"46": "636",
			"47": "636",
			"48": "636",
			"49": "636",
			"50": "636",
			"51": "636",
			"52": "636",
			"53": "636",
			"54": "636",
			"55": "636",
			"56": "636",
			"57": "636",
			"58": "636",
			"59": "636",
			"60": "0",
			"61": "0",
			"62": "0",
			"63": "0",
			"64": "0",
			"65": "0",
			"66": "0",
			"67": "0",
			"68": "0",
			"69": "0",
			"70": "0",
			"71": "0",
			"72": "0",
			"73": "0",
			"74": "0",
			"75": "0",
			"76": "0",
			"77": "0",
			"78": "0",
			"79": "0",
			"80": "0",
			"81": "0",
			"82": "0",
			"83": "0",
			"84": "0",
			"85": "0",
			"86": "0",
			"87": "0",
			"category": "rqap"
		},
		{
			"18": "98",
			"19": "98",
			"20": "98",
			"21": "459",
			"22": "474",
			"23": "494",
			"24": "511",
			"25": "531",
			"26": "550",
			"27": "1215",
			"28": "1249",
			"29": "626",
			"30": "1311",
			"31": "652",
			"32": "1344",
			"33": "1344",
			"34": "1344",
			"35": "1344",
			"36": "1344",
			"37": "1344",
			"38": "1344",
			"39": "1344",
			"40": "1344",
			"41": "1344",
			"42": "1344",
			"43": "1344",
			"44": "1344",
			"45": "1344",
			"46": "1344",
			"47": "1344",
			"48": "1344",
			"49": "1344",
			"50": "1344",
			"51": "1344",
			"52": "1344",
			"53": "1344",
			"54": "1344",
			"55": "1344",
			"56": "1344",
			"57": "1344",
			"58": "1344",
			"59": "1344",
			"60": "0",
			"61": "0",
			"62": "0",
			"63": "0",
			"64": "0",
			"65": "0",
			"66": "0",
			"67": "0",
			"68": "0",
			"69": "0",
			"70": "0",
			"71": "0",
			"72": "0",
			"73": "0",
			"74": "0",
			"75": "0",
			"76": "0",
			"77": "0",
			"78": "0",
			"79": "0",
			"80": "0",
			"81": "0",
			"82": "0",
			"83": "0",
			"84": "0",
			"85": "0",
			"86": "0",
			"87": "0",
			"category": "ae"
		},
		{
			"18": "1188",
			"19": "1188",
			"20": "1188",
			"21": "1759",
			"22": "1759",
			"23": "1759",
			"24": "1759",
			"25": "2239",
			"26": "2239",
			"27": "4183",
			"28": "4183",
			"29": "3965",
			"30": "4705",
			"31": "4705",
			"32": "4800",
			"33": "4800",
			"34": "4800",
			"35": "4998",
			"36": "4998",
			"37": "4998",
			"38": "4998",
			"39": "4998",
			"40": "5179",
			"41": "5179",
			"42": "5179",
			"43": "5179",
			"44": "5179",
			"45": "5345",
			"46": "5345",
			"47": "5345",
			"48": "5345",
			"49": "5251",
			"50": "5401",
			"51": "5401",
			"52": "5029",
			"53": "5029",
			"54": "5029",
			"55": "5024",
			"56": "5024",
			"57": "5024",
			"58": "5024",
			"59": "5024",
			"60": "3941",
			"61": "3941",
			"62": "4400",
			"63": "4400",
			"64": "4400",
			"65": "4358",
			"66": "4358",
			"67": "4358",
			"68": "4358",
			"69": "4358",
			"70": "4298",
			"71": "4298",
			"72": "4298",
			"73": "4298",
			"74": "4298",
			"75": "4221",
			"76": "4221",
			"77": "4221",
			"78": "4221",
			"79": "4221",
			"80": "4125",
			"81": "4125",
			"82": "1993",
			"83": "1993",
			"84": "1993",
			"85": "1895",
			"86": "1895",
			"87": "1895",
			"category": "taxes"
		},
		{
			"29": "115",
			"31": "135",
			"60": "198",
			"61": "198",
			"62": "198",
			"63": "198",
			"64": "198",
			"65": "198",
			"66": "198",
			"67": "198",
			"68": "198",
			"69": "198",
			"70": "198",
			"71": "198",
			"72": "198",
			"73": "198",
			"74": "198",
			"75": "198",
			"76": "198",
			"77": "198",
			"78": "198",
			"79": "198",
			"80": "198",
			"81": "198",
			"82": "150",
			"83": "150",
			"84": "150",
			"85": "150",
			"86": "150",
			"87": "150",
			"category": "fond-service-sante"
		},
		{
			"60": "1283",
			"61": "1283",
			"62": "1283",
			"63": "1283",
			"64": "1283",
			"65": "1283",
			"66": "1283",
			"67": "1283",
			"68": "1283",
			"69": "1283",
			"70": "1283",
			"71": "1283",
			"72": "1283",
			"73": "1283",
			"74": "1283",
			"75": "1283",
			"76": "1283",
			"77": "1283",
			"78": "1283",
			"79": "1283",
			"80": "1283",
			"81": "1283",
			"82": "642",
			"83": "642",
			"84": "642",
			"85": "642",
			"86": "642",
			"87": "642",
			"category": "regime-assurance-medicament"
		},
		{
			"18": "284",
			"19": "284",
			"20": "284",
			"21": "433",
			"22": "433",
			"23": "433",
			"24": "433",
			"25": "399",
			"26": "338",
			"category": "credit-tps"
		},
		{
			"18": "287",
			"19": "287",
			"20": "287",
			"21": "981",
			"22": "981",
			"23": "962",
			"24": "893",
			"25": "812",
			"26": "737",
			"82": "155.08",
			"83": "155.08",
			"84": "155.08",
			"85": "155.08",
			"86": "155.08",
			"87": "155.08",
			"category": "credit-solidarite"
		},
		{
			"18": "0",
			"19": "0",
			"20": "0",
			"21": "0",
			"22": "0",
			"23": "0",
			"24": "0",
			"25": "0",
			"26": "0",
			"62": "7121",
			"63": "7121",
			"64": "7121",
			"65": "14243",
			"66": "14243",
			"67": "14243",
			"68": "14243",
			"69": "14243",
			"70": "14243",
			"71": "14243",
			"72": "14243",
			"73": "14243",
			"74": "14243",
			"75": "14243",
			"76": "14243",
			"77": "14243",
			"78": "14243",
			"79": "14243",
			"80": "14243",
			"81": "14243",
			"82": "7121",
			"83": "7121",
			"84": "7121",
			"85": "7121",
			"86": "7121",
			"87": "7121",
			"category": "pension"
		},
		{
			"29": "3650",
			"30": "3216",
			"31": "7668",
			"32": "6636",
			"33": "6582",
			"34": "6475",
			"35": "5405",
			"36": "5267",
			"37": "4195",
			"38": "4177",
			"39": "4120",
			"40": "4063",
			"41": "3841",
			"42": "3841",
			"43": "3841",
			"44": "3841",
			"45": "3841",
			"46": "3841",
			"47": "1689",
			"48": "1689",
			"category": "allocation-cad-enfants"
		},
		{
			"29": "1324",
			"30": "686",
			"31": "2809",
			"32": "1968",
			"33": "1928",
			"34": "1888",
			"35": "1848",
			"36": "1808",
			"37": "1768",
			"38": "1755",
			"39": "1715",
			"40": "1675",
			"41": "1649",
			"42": "1649",
			"43": "1649",
			"44": "1649",
			"45": "1649",
			"46": "1649",
			"47": "682",
			"48": "682",
			"category": "paiement-soutien-enfants"
		},
		{
			"33": "100",
			"34": "100",
			"35": "200",
			"36": "200",
			"37": "200",
			"38": "200",
			"39": "200",
			"40": "200",
			"41": "200",
			"42": "200",
			"43": "200",
			"44": "200",
			"45": "200",
			"46": "100",
			"47": "100",
			"category": "allocation-fournitures-scolaires"
		},
		{
			"75": "814",
			"76": "814",
			"77": "814",
			"78": "814",
			"79": "814",
			"80": "814",
			"81": "814",
			"82": "605",
			"83": "605",
			"84": "605",
			"85": "605",
			"86": "605",
			"87": "605",
			"category": "cisd"
		},
		{
			"18": "1668",
			"19": "1668",
			"20": "1945",
			"21": "1945",
			"22": "1945",
			"23": "1945",
			"24": "1945",
			"25": "2706",
			"26": "2706",
			"27": "4282",
			"28": "4282",
			"29": "14001",
			"30": "6255",
			"31": "14919",
			"32": "7984",
			"33": "7984",
			"34": "7673",
			"35": "7328",
			"36": "7065",
			"37": "7291",
			"38": "7291",
			"39": "7127",
			"40": "6884",
			"41": "6839",
			"42": "7256",
			"43": "7256",
			"44": "7398",
			"45": "7632",
			"46": "7978",
			"47": "7026",
			"48": "7026",
			"49": "5358",
			"50": "5738",
			"51": "5738",
			"52": "6463",
			"53": "6463",
			"54": "6463",
			"55": "7004",
			"56": "7004",
			"57": "8041",
			"58": "8041",
			"59": "8041",
			"60": "8923",
			"61": "8923",
			"62": "10848",
			"63": "10848",
			"64": "10848",
			"65": "12490",
			"66": "12490",
			"67": "14673",
			"68": "14673",
			"69": "14673",
			"70": "16401",
			"71": "16401",
			"72": "19917",
			"73": "19917",
			"74": "19917",
			"75": "23341",
			"76": "23341",
			"77": "28157",
			"78": "28157",
			"79": "28157",
			"80": "33811",
			"81": "33811",
			"82": "16782",
			"83": "16782",
			"84": "16782",
			"85": "28143",
			"86": "28143",
			"87": "28143",
			"category": "sante"
		},
		{
			"18": "12238",
			"19": "12238",
			"20": "12238",
			"21": "0",
			"22": "0",
			"23": "0",
			"24": "0",
			"25": "0",
			"26": "0",
			"27": "0",
			"28": "0",
			"46": "12238",
			"48": "12238",
			"category": "service-es"
		},
		{
			"30": "10266",
			"31": "10266",
			"32": "20531",
			"33": "20531",
			"34": "10266",
			"35": "10266",
			"category": "service-de-garde"
		},
		{
			"34": "758",
			"35": "758",
			"36": "1516",
			"37": "1516",
			"38": "1516",
			"39": "1516",
			"40": "1516",
			"category": "service-de-garde-scolaire"
		},
		{
			"34": "5848",
			"35": "5848",
			"36": "11696",
			"37": "11696",
			"38": "11696",
			"39": "11696",
			"40": "11696",
			"41": "12256",
			"42": "12256",
			"43": "12816",
			"44": "12816",
			"45": "12816",
			"46": "6408",
			"47": "6408",
			"category": "primaire-secondaire"
		},
		{
			"29": "30950",
			"31": "33141",
			"category": "regime-assurance-parentale"
		},
		{
			"60": "1010",
			"61": "1010",
			"62": "1877",
			"63": "1839",
			"64": "1839",
			"65": "2744",
			"66": "2744",
			"67": "2744",
			"68": "2744",
			"69": "2744",
			"70": "2744",
			"71": "2744",
			"72": "2744",
			"73": "2744",
			"74": "2744",
			"75": "2744",
			"76": "2744",
			"77": "2744",
			"78": "2744",
			"79": "2744",
			"80": "2744",
			"81": "2744",
			"82": "1372",
			"83": "1372",
			"84": "1372",
			"85": "1372",
			"86": "1372",
			"87": "1372",
			"category": "assurance-medicament"
		},
		{
			"18": "0",
			"19": "0",
			"20": "0",
			"21": "0",
			"22": "0",
			"23": "0",
			"24": "0",
			"25": "0",
			"26": "0",
			"27": "0",
			"28": "0",
			"29": "0",
			"30": "0",
			"31": "0",
			"32": "0",
			"33": "0",
			"34": "0",
			"35": "0",
			"36": "0",
			"37": "0",
			"38": "0",
			"39": "0",
			"40": "0",
			"41": "0",
			"42": "0",
			"43": "0",
			"44": "0",
			"45": "0",
			"46": "0",
			"47": "0",
			"48": "0",
			"49": "0",
			"50": "0",
			"51": "0",
			"52": "0",
			"53": "0",
			"54": "0",
			"55": "0",
			"56": "0",
			"57": "0",
			"58": "0",
			"59": "0",
			"60": "10716",
			"61": "19221",
			"62": "19221",
			"63": "19221",
			"64": "19221",
			"65": "19221",
			"66": "19221",
			"67": "19221",
			"68": "19221",
			"69": "19221",
			"70": "19221",
			"71": "19221",
			"72": "19221",
			"73": "19221",
			"74": "19221",
			"75": "19221",
			"76": "19221",
			"77": "19221",
			"78": "19221",
			"79": "19221",
			"80": "19221",
			"81": "19221",
			"82": "12524",
			"83": "12524",
			"84": "12524",
			"85": "12524",
			"86": "12524",
			"87": "12524",
			"category": "rentes"
		}
	],
	"monoparentale": [
		{
			"18": "7529",
			"19": "7529",
			"20": "7529",
			"21": "35302",
			"22": "36471",
			"23": "37987",
			"24": "39302",
			"25": "40854",
			"26": "42279",
			"27": "93443",
			"28": "96067",
			"29": "48148",
			"30": "101552",
			"31": "104414",
			"32": "107385",
			"33": "108384",
			"34": "109383",
			"35": "110381",
			"36": "111380",
			"37": "112379",
			"38": "113377",
			"39": "114376",
			"40": "52963",
			"41": "52963",
			"42": "52963",
			"43": "52963",
			"44": "52963",
			"45": "52963",
			"46": "52963",
			"47": "52963",
			"48": "52963",
			"49": "52963",
			"50": "52963",
			"51": "52963",
			"52": "52963",
			"53": "52963",
			"54": "52963",
			"55": "52963",
			"56": "52963",
			"57": "52963",
			"58": "52963",
			"59": "52963",
			"60": "0",
			"61": "0",
			"62": "0",
			"63": "0",
			"64": "0",
			"65": "0",
			"66": "0",
			"67": "0",
			"68": "0",
			"69": "0",
			"70": "0",
			"71": "0",
			"72": "0",
			"73": "0",
			"74": "0",
			"75": "0",
			"76": "0",
			"77": "0",
			"78": "0",
			"79": "0",
			"80": "0",
			"81": "0",
			"82": "0",
			"83": "0",
			"84": "0",
			"85": "0",
			"86": "0",
			"87": "0",
			"category": "revenu-salaire"
		},
		{
			"18": "0",
			"19": "0",
			"20": "0",
			"21": "0",
			"22": "0",
			"23": "0",
			"24": "0",
			"25": "0",
			"26": "0",
			"27": "0",
			"28": "0",
			"29": "0",
			"30": "0",
			"31": "0",
			"32": "0",
			"33": "0",
			"34": "0",
			"35": "0",
			"36": "0",
			"37": "0",
			"38": "0",
			"39": "0",
			"40": "0",
			"41": "0",
			"42": "0",
			"43": "0",
			"44": "0",
			"45": "0",
			"46": "0",
			"47": "0",
			"48": "0",
			"49": "0",
			"50": "0",
			"51": "0",
			"52": "0",
			"53": "0",
			"54": "0",
			"55": "0",
			"56": "0",
			"57": "0",
			"58": "0",
			"59": "0",
			"60": "41311",
			"61": "41311",
			"62": "41311",
			"63": "41311",
			"64": "41311",
			"65": "28335",
			"66": "28335",
			"67": "28335",
			"68": "28335",
			"69": "28335",
			"70": "28335",
			"71": "28335",
			"72": "28335",
			"73": "28335",
			"74": "28335",
			"75": "28335",
			"76": "28335",
			"77": "28335",
			"78": "28335",
			"79": "28335",
			"80": "28335",
			"81": "28335",
			"82": "28335",
			"83": "28335",
			"84": "28335",
			"85": "28335",
			"86": "28335",
			"87": "28335",
			"category": "revenu-retraite"
		},
		{
			"18": "0",
			"19": "0",
			"20": "0",
			"21": "4466",
			"22": "4732",
			"23": "5092",
			"24": "5424",
			"25": "5816",
			"26": "6176",
			"27": "16228",
			"28": "15599",
			"29": "13274",
			"30": "16834",
			"31": "17692",
			"32": "18580",
			"33": "18939",
			"34": "19475",
			"35": "19845",
			"36": "20215",
			"37": "20585",
			"38": "20706",
			"39": "21076",
			"40": "7567",
			"41": "7567",
			"42": "7567",
			"43": "7567",
			"44": "7567",
			"45": "7567",
			"46": "6626",
			"47": "8577",
			"48": "8577",
			"49": "8577",
			"50": "9046",
			"51": "9046",
			"52": "9046",
			"53": "9046",
			"54": "9046",
			"55": "9046",
			"56": "9046",
			"57": "9046",
			"58": "9046",
			"59": "9046",
			"60": "6915",
			"61": "9981",
			"62": "9981",
			"63": "9981",
			"64": "9981",
			"65": "6504",
			"66": "6504",
			"67": "6504",
			"68": "6504",
			"69": "6504",
			"70": "6504",
			"71": "6504",
			"72": "6504",
			"73": "6504",
			"74": "6504",
			"75": "6504",
			"76": "6504",
			"77": "6504",
			"78": "6504",
			"79": "6504",
			"80": "6504",
			"81": "6504",
			"82": "6504",
			"83": "6504",
			"84": "6504",
			"85": "6504",
			"86": "6504",
			"87": "6504",
			"category": "impot"
		},
		{
			"30": "650",
			"31": "749",
			"32": "845",
			"33": "881",
			"category": "frais-de-garde"
		},
		{
			"18": "218",
			"19": "218",
			"20": "218",
			"21": "1717",
			"22": "1780",
			"23": "1862",
			"24": "1933",
			"25": "2017",
			"26": "2094",
			"27": "4668",
			"28": "4810",
			"29": "2222",
			"30": "5106",
			"31": "5260",
			"32": "5421",
			"33": "5475",
			"34": "5501",
			"35": "5501",
			"36": "5501",
			"37": "5501",
			"38": "5501",
			"39": "5501",
			"40": "2671",
			"41": "2671",
			"42": "2671",
			"43": "2671",
			"44": "2671",
			"45": "2671",
			"46": "2671",
			"47": "2671",
			"48": "2671",
			"49": "2671",
			"50": "2671",
			"51": "2671",
			"52": "2671",
			"53": "2671",
			"54": "2671",
			"55": "2671",
			"56": "2671",
			"57": "2671",
			"58": "2671",
			"59": "2671",
			"category": "rrq"
		},
		{
			"18": "41",
			"19": "41",
			"20": "41",
			"21": "193",
			"22": "200",
			"23": "208",
			"24": "215",
			"25": "224",
			"26": "232",
			"27": "512",
			"28": "526",
			"29": "264",
			"30": "556",
			"31": "572",
			"32": "588",
			"33": "594",
			"34": "599",
			"35": "605",
			"36": "610",
			"37": "616",
			"38": "621",
			"39": "627",
			"40": "290",
			"41": "290",
			"42": "290",
			"43": "290",
			"44": "290",
			"45": "290",
			"46": "290",
			"47": "290",
			"48": "290",
			"49": "290",
			"50": "290",
			"51": "290",
			"52": "290",
			"53": "290",
			"54": "290",
			"55": "290",
			"56": "290",
			"57": "290",
			"58": "290",
			"59": "290",
			"category": "rqap"
		},
		{
			"18": "98",
			"19": "98",
			"20": "98",
			"21": "459",
			"22": "474",
			"23": "494",
			"24": "511",
			"25": "531",
			"26": "550",
			"27": "1215",
			"28": "1249",
			"29": "626",
			"30": "1311",
			"31": "1335",
			"32": "1344",
			"33": "1344",
			"34": "1344",
			"35": "1344",
			"36": "1344",
			"37": "1344",
			"38": "1344",
			"39": "1344",
			"40": "672",
			"41": "672",
			"42": "672",
			"43": "672",
			"44": "672",
			"45": "672",
			"46": "672",
			"47": "672",
			"48": "672",
			"49": "672",
			"50": "672",
			"51": "672",
			"52": "672",
			"53": "672",
			"54": "672",
			"55": "672",
			"56": "672",
			"57": "672",
			"58": "672",
			"59": "672",
			"category": "ae"
		},
		{
			"18": "1188",
			"19": "1188",
			"20": "1188",
			"21": "1759",
			"22": "1759",
			"23": "1759",
			"24": "1759",
			"25": "2239",
			"26": "2239",
			"27": "4183",
			"28": "4183",
			"29": "3965",
			"30": "4705",
			"31": "4705",
			"32": "4800",
			"33": "4800",
			"34": "4800",
			"35": "4998",
			"36": "4998",
			"37": "4998",
			"38": "4998",
			"39": "4998",
			"40": "3856",
			"41": "3856",
			"42": "3856",
			"43": "3856",
			"44": "3856",
			"45": "4010",
			"46": "4010",
			"47": "3125",
			"48": "3125",
			"49": "3125",
			"50": "2334",
			"51": "2334",
			"52": "2334",
			"53": "2334",
			"54": "2334",
			"55": "2307",
			"56": "2307",
			"57": "2307",
			"58": "2307",
			"59": "2307",
			"60": "2268",
			"61": "2268",
			"62": "2268",
			"63": "2268",
			"64": "2268",
			"65": "2217",
			"66": "2217",
			"67": "2217",
			"68": "2217",
			"69": "2217",
			"70": "2154",
			"71": "2154",
			"72": "2154",
			"73": "2154",
			"74": "2154",
			"75": "2080",
			"76": "2080",
			"77": "2080",
			"78": "2080",
			"79": "2080",
			"80": "1993",
			"81": "1993",
			"82": "1993",
			"83": "1993",
			"84": "1993",
			"85": "1895",
			"86": "1895",
			"87": "1895",
			"category": "taxes"
		},
		{
			"29": "115",
			"60": "150",
			"61": "150",
			"62": "150",
			"63": "150",
			"64": "150",
			"65": "150",
			"66": "150",
			"67": "150",
			"68": "150",
			"69": "150",
			"70": "150",
			"71": "150",
			"72": "150",
			"73": "150",
			"74": "150",
			"75": "150",
			"76": "150",
			"77": "150",
			"78": "150",
			"79": "150",
			"80": "150",
			"81": "150",
			"82": "150",
			"83": "150",
			"84": "150",
			"85": "150",
			"86": "150",
			"87": "150",
			"category": "fond-service-sante"
		},
		{
			"60": "642",
			"61": "642",
			"62": "642",
			"63": "642",
			"64": "642",
			"65": "642",
			"66": "642",
			"67": "642",
			"68": "642",
			"69": "642",
			"70": "642",
			"71": "642",
			"72": "642",
			"73": "642",
			"74": "642",
			"75": "642",
			"76": "642",
			"77": "642",
			"78": "642",
			"79": "642",
			"80": "642",
			"81": "642",
			"82": "642",
			"83": "642",
			"84": "642",
			"85": "642",
			"86": "642",
			"87": "642",
			"category": "regime-assurance-medicament"
		},
		{
			"18": "284",
			"19": "284",
			"20": "284",
			"21": "433",
			"22": "433",
			"23": "433",
			"24": "433",
			"25": "399",
			"26": "338",
			"27": "0",
			"28": "0",
			"29": "0",
			"30": "0",
			"40": "163",
			"41": "163",
			"42": "163",
			"43": "163",
			"44": "163",
			"45": "163",
			"46": "163",
			"47": "0",
			"48": "0",
			"49": "0",
			"50": "0",
			"51": "0",
			"52": "0",
			"53": "0",
			"54": "0",
			"55": "0",
			"56": "0",
			"57": "0",
			"58": "0",
			"59": "0",
			"60": "216",
			"61": "0",
			"62": "0",
			"63": "0",
			"64": "0",
			"65": "84",
			"66": "84",
			"67": "84",
			"68": "84",
			"69": "84",
			"70": "84",
			"71": "84",
			"72": "84",
			"73": "84",
			"74": "84",
			"75": "84",
			"76": "84",
			"77": "84",
			"78": "84",
			"79": "84",
			"80": "84",
			"81": "84",
			"82": "84",
			"83": "84",
			"84": "84",
			"85": "84",
			"86": "84",
			"87": "84",
			"category": "credit-tps"
		},
		{
			"18": "287",
			"19": "287",
			"20": "287",
			"21": "981",
			"22": "981",
			"23": "962",
			"24": "893",
			"25": "812",
			"26": "737",
			"27": "0",
			"28": "0",
			"29": "0",
			"30": "0",
			"40": "298",
			"41": "298",
			"42": "298",
			"43": "298",
			"44": "298",
			"45": "298",
			"46": "298",
			"47": "0",
			"48": "0",
			"49": "0",
			"50": "179",
			"51": "179",
			"52": "179",
			"53": "179",
			"54": "179",
			"55": "179",
			"56": "179",
			"57": "179",
			"58": "179",
			"59": "179",
			"60": "555",
			"61": "45",
			"62": "45",
			"63": "45",
			"64": "45",
			"65": "396",
			"66": "396",
			"67": "396",
			"68": "396",
			"69": "396",
			"70": "396",
			"71": "396",
			"72": "396",
			"73": "396",
			"74": "396",
			"75": "396",
			"76": "396",
			"77": "396",
			"78": "396",
			"79": "396",
			"80": "396",
			"81": "396",
			"82": "396",
			"83": "396",
			"84": "396",
			"85": "396",
			"86": "396",
			"87": "396",
			"category": "credit-solidarite"
		},
		{
			"18": "0",
			"19": "0",
			"20": "0",
			"21": "0",
			"22": "0",
			"23": "0",
			"24": "0",
			"25": "0",
			"26": "0",
			"27": "0",
			"28": "0",
			"29": "0",
			"30": "0",
			"50": "0",
			"51": "0",
			"52": "0",
			"53": "0",
			"54": "0",
			"55": "0",
			"56": "0",
			"57": "0",
			"58": "0",
			"59": "0",
			"60": "0",
			"61": "0",
			"62": "0",
			"63": "0",
			"64": "0",
			"65": "7121",
			"66": "7121",
			"67": "7121",
			"68": "7121",
			"69": "7121",
			"70": "7121",
			"71": "7121",
			"72": "7121",
			"73": "7121",
			"74": "7121",
			"75": "7121",
			"76": "7121",
			"77": "7121",
			"78": "7121",
			"79": "7121",
			"80": "7121",
			"81": "7121",
			"82": "7121",
			"83": "7121",
			"84": "7121",
			"85": "7121",
			"86": "7121",
			"87": "7121",
			"category": "pension"
		},
		{
			"18": "0",
			"19": "0",
			"20": "0",
			"21": "0",
			"22": "0",
			"23": "0",
			"24": "0",
			"25": "0",
			"26": "0",
			"27": "0",
			"28": "0",
			"29": "3650",
			"30": "3216",
			"31": "3136",
			"32": "3053",
			"33": "3022",
			"34": "2947",
			"35": "1900",
			"36": "1868",
			"37": "1836",
			"38": "1825",
			"39": "1793",
			"40": "4249",
			"41": "4249",
			"42": "4249",
			"43": "4249",
			"44": "4249",
			"45": "4249",
			"46": "4249",
			"category": "allocation-cad-enfants"
		},
		{
			"18": "0",
			"19": "0",
			"20": "0",
			"21": "0",
			"22": "0",
			"23": "0",
			"24": "0",
			"25": "0",
			"26": "0",
			"27": "0",
			"28": "0",
			"29": "1324",
			"30": "686",
			"31": "682",
			"32": "682",
			"33": "682",
			"34": "682",
			"35": "682",
			"36": "682",
			"37": "682",
			"38": "682",
			"39": "682",
			"40": "2782",
			"41": "2782",
			"42": "2782",
			"43": "2782",
			"44": "2782",
			"45": "2782",
			"46": "2782",
			"category": "paiement-soutien-enfants"
		},
		{
			"18": "0",
			"19": "0",
			"20": "0",
			"21": "0",
			"22": "0",
			"23": "0",
			"24": "0",
			"25": "0",
			"26": "0",
			"27": "0",
			"28": "0",
			"29": "0",
			"30": "0",
			"33": "100",
			"34": "100",
			"35": "100",
			"36": "100",
			"37": "100",
			"38": "100",
			"39": "100",
			"40": "100",
			"41": "100",
			"42": "100",
			"43": "100",
			"44": "100",
			"45": "100",
			"category": "allocation-fournitures-scolaires"
		},
		{
			"75": "605",
			"76": "605",
			"77": "605",
			"78": "605",
			"79": "605",
			"80": "605",
			"81": "605",
			"82": "605",
			"83": "605",
			"84": "605",
			"85": "605",
			"86": "605",
			"87": "605",
			"category": "cisd"
		},
		{
			"18": "1668",
			"19": "1668",
			"20": "1945",
			"21": "1945",
			"22": "1945",
			"23": "1945",
			"24": "1945",
			"25": "2706",
			"26": "2706",
			"27": "4282",
			"28": "4282",
			"29": "14001",
			"30": "6255",
			"31": "6255",
			"32": "6353",
			"33": "6353",
			"34": "6041",
			"35": "5697",
			"36": "5697",
			"37": "5923",
			"38": "5923",
			"39": "5759",
			"40": "3615",
			"41": "3615",
			"42": "3615",
			"43": "3615",
			"44": "3757",
			"45": "3992",
			"46": "3992",
			"47": "2531",
			"48": "2531",
			"49": "2531",
			"50": "2910",
			"51": "2910",
			"52": "2910",
			"53": "2910",
			"54": "2910",
			"55": "3452",
			"56": "3452",
			"57": "3452",
			"58": "3452",
			"59": "3452",
			"60": "4333",
			"61": "4333",
			"62": "4333",
			"63": "4333",
			"64": "4333",
			"65": "5975",
			"66": "5975",
			"67": "5975",
			"68": "5975",
			"69": "5975",
			"70": "7704",
			"71": "7704",
			"72": "7704",
			"73": "7704",
			"74": "7704",
			"75": "11129",
			"76": "11129",
			"77": "11129",
			"78": "11129",
			"79": "11129",
			"80": "16782",
			"81": "16782",
			"82": "16782",
			"83": "16782",
			"84": "16782",
			"85": "28143",
			"86": "28143",
			"87": "28143",
			"category": "sante"
		},
		{
			"18": "12238",
			"19": "12238",
			"20": "12238",
			"21": "0",
			"22": "0",
			"23": "0",
			"46": "12238",
			"category": "service-es"
		},
		{
			"30": "10266",
			"31": "10266",
			"32": "10266",
			"33": "10266",
			"category": "service-de-garde"
		},
		{
			"34": "758",
			"35": "758",
			"36": "758",
			"37": "758",
			"38": "758",
			"39": "758",
			"category": "service-de-garde-scolaire"
		},
		{
			"34": "5848",
			"35": "5848",
			"36": "5848",
			"37": "5848",
			"38": "5848",
			"39": "5848",
			"40": "5848",
			"41": "6408",
			"42": "6408",
			"43": "6408",
			"44": "6408",
			"45": "6408",
			"category": "primaire-secondaire"
		},
		{
			"29": "30950",
			"category": "regime-assurance-parentale"
		},
		{
			"18": "0",
			"19": "0",
			"20": "0",
			"21": "0",
			"22": "0",
			"23": "0",
			"24": "0",
			"25": "0",
			"26": "0",
			"50": "0",
			"51": "0",
			"52": "0",
			"53": "0",
			"54": "0",
			"55": "0",
			"56": "0",
			"57": "0",
			"58": "0",
			"59": "0",
			"60": "505",
			"61": "505",
			"62": "505",
			"63": "505",
			"64": "505",
			"65": "1372",
			"66": "1372",
			"67": "1372",
			"68": "1372",
			"69": "1372",
			"70": "1372",
			"71": "1372",
			"72": "1372",
			"73": "1372",
			"74": "1372",
			"75": "1372",
			"76": "1372",
			"77": "1372",
			"78": "1372",
			"79": "1372",
			"80": "1372",
			"81": "1372",
			"82": "1372",
			"83": "1372",
			"84": "1372",
			"85": "1372",
			"86": "1372",
			"87": "1372",
			"category": "assurance-medicament"
		},
		{
			"50": "0",
			"51": "0",
			"52": "0",
			"53": "0",
			"54": "0",
			"55": "0",
			"56": "0",
			"57": "0",
			"58": "0",
			"59": "0",
			"60": "0",
			"61": "8505",
			"62": "8505",
			"63": "8505",
			"64": "8505",
			"65": "8505",
			"66": "8505",
			"67": "8505",
			"68": "8505",
			"69": "8505",
			"70": "8505",
			"71": "8505",
			"72": "8505",
			"73": "8505",
			"74": "8505",
			"75": "8505",
			"76": "8505",
			"77": "8505",
			"78": "8505",
			"79": "8505",
			"80": "8505",
			"81": "8505",
			"82": "8505",
			"83": "8505",
			"84": "8505",
			"85": "8505",
			"86": "8505",
			"87": "8505",
			"category": "rentes"
		}
	]
};